<h2 class="mt-0">{{ 'components.client-search-form.title' | translate }}</h2>

<form [formGroup]="form">
    <app-form-error [error]="error" />
    <mat-tab-group (selectedIndexChange)="changeSearchMode($event)">
        <mat-tab [label]="'form.labels.medium' | translate">
            <form-select
                [formControlName]="clientSearchFormField.MediumType"
                [label]="'form.labels.mediumType' | translate"
                [options]="mediumTypes()" />

            <form-input [formControlName]="clientSearchFormField.MediumN" [label]="'form.labels.mediumN' | translate" />

            @if (mediumTypeValue === mediumType.BankCard) {
                <div class="d-flex flex-row align-items-center agent-client-search-form-field-expDate">
                    <form-select
                        [formControlName]="clientSearchFormField.ExpDateMonth"
                        [label]="'form.labels.month' | translate"
                        [translateOptions]="true"
                        [options]="monthList" />

                    <form-input
                        [formControlName]="clientSearchFormField.ExpDateYear"
                        [label]="'form.labels.year' | translate" />
                </div>
            }
        </mat-tab>
        <mat-tab [label]="'form.labels.sid' | translate">
            <form-input [formControlName]="clientSearchFormField.MediumSid" [iconPrefix]="'qr_code_scanner'" />
        </mat-tab>
        <mat-tab [label]="'form.labels.phone' | translate">
            <div class="d-flex flex-row flex-nowrap agent-client-search-form-">
                <form-input
                    class="agent-client-search-form-field-phone-code"
                    [formControlName]="clientSearchFormField.PhoneCode"
                    [showErrorMessage]="false"
                    [iconPrefix]="'add'" />

                <form-input
                    class="agent-client-search-form-field-phone"
                    [formControlName]="clientSearchFormField.Mobnum"
                    [inputMode]="'tel'"
                    [placeholder]="'XXXXXXXXX'" />
            </div>
        </mat-tab>

        <mat-tab [label]="'form.labels.email' | translate">
            <form-input
                [formControlName]="clientSearchFormField.Email"
                [iconPrefix]="'alternate_email'"
                [inputMode]="'email'"
                [type]="'email'" />
        </mat-tab>
    </mat-tab-group>

    <form-button
        [disabled]="form.status === 'INVALID' || form.status === 'PENDING'"
        [label]="'actions.search' | translate"
        [loading]="form.status === 'PENDING'"
        (click)="handlerSubmit()" />
</form>
